import MDBox from "components/MDBox";
import JobsScheduleCalendarOnly from "./JobsScheduleCalendarOnly";
import JobsScheduleMapView from "./JobsScheduleMapView";
import { JobStatus } from "generated/graphql";
import useJobsTableData from "hooks/jobs/useJobsTableData";

export default function CalendarSection({
  jobs,
  jobsLoading,
  selectedProductTypes,
  selectedJobStatuses,
  onJobStatusesChange,
  onProductTypeChange,
  view,
  onViewChange,
}: {
  jobs: any[];
  jobsLoading: boolean;
  selectedProductTypes: Array<{ label?: string; value: string | number }>;
  selectedJobStatuses: JobStatus[];
  onJobStatusesChange: (statuses: JobStatus[]) => void;
  onProductTypeChange: ReturnType<typeof useJobsTableData>["setOrganizationProductTypeIds"];
  view: "calendar" | "map";
  onViewChange: (view: "calendar" | "map") => void;
}) {
  return (
    <MDBox
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f7f9fa!important",
      }}
    >
      <MDBox sx={{ flex: 1, minHeight: 0 }}>
        {view === "calendar" ? (
          <JobsScheduleCalendarOnly view={view} onViewChange={onViewChange} />
        ) : (
          <JobsScheduleMapView
            jobs={jobs}
            jobsLoading={jobsLoading}
            selectedProductTypes={selectedProductTypes}
            selectedJobStatuses={selectedJobStatuses}
            onJobStatusesChange={onJobStatusesChange}
            onProductTypeChange={onProductTypeChange}
            view={view}
            onViewChange={onViewChange}
          />
        )}
      </MDBox>
    </MDBox>
  );
}
